module.exports = __webpack_public_path__ + "img/s04.afd1fd3a.png";